import React, { useEffect, useState, useMemo } from 'react';
import { makeStyles, Container, Grid, Paper, CircularProgress } from '@material-ui/core';
import { injectIntl, FormattedMessage } from 'react-intl';
import Breadcrumb from 'app/components/BreadCrumb';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

import styles from './styles';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { URLS } from 'app/config/urls';
import moment from 'moment';
import { fetchUserAdmin, getLoggedInUser } from 'app/store/slices/user';
import { downloadFile } from 'app/utils/forms/files';
import CompanyData from './CompanyData';
import PersonData from './PersonData';
const useStyles = makeStyles(styles);

function Company(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { intl } = props;

  const activeCompany = useSelector(state => state.company.activeCompany);
  const user = useSelector(state => state.auth.user);
  const registrationUserInfo = useSelector(state => state.auth.registrationInfo);
  const userAdmin = useSelector(state => state.auth.userAdmin);

  const [loading, setLoading] = useState(true);
  const [hasCRC, setHasCRC] = useState(false);
  const [requesterType, setRequesterType] = useState('company');

  const [pageTitle, setPageTitle] = useState(
    intl.formatMessage({ id: 'LABELS.COMMONS.COMPANY_DATA' })
  );

  const companyData = useMemo(() => {
    if (activeCompany && Object.keys(activeCompany).length > 0) {
      if (activeCompany.boSituacaoOrgao) {
        if (activeCompany.certificado?.idFileCrc && activeCompany.certificado?.idFileCrc !== '') {
          setHasCRC(true);
        }
      }
      return activeCompany;
    } else if (user.cdUsuarioAdmin) {
      setPageTitle(intl.formatMessage({ id: 'LABELS.COMMONS.REQUESTER_DATA' }));
      return userAdmin;
    } else if (registrationUserInfo && Object.keys(registrationUserInfo).length > 0) {
      setPageTitle(intl.formatMessage({ id: 'LABELS.COMMONS.REQUESTER_DATA' }));
      return registrationUserInfo;
    }
    return {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCompany, registrationUserInfo, userAdmin]);

  const organSituation = useMemo(() => {
    let result = 'Inativa';
    let boSituacaoOrgao = companyData.boSituacaoOrgao !== null ? companyData.boSituacaoOrgao : null;
    if (boSituacaoOrgao) result = 'Ativa';

    if (activeCompany.certificado && activeCompany.certificado.dtVencimentoCrc) {
      const diffDays = moment.utc().diff(activeCompany.certificado.dtVencimentoCrc, 'days');
      if (diffDays >= 0) result = 'Vencida';
    }

    return result;
  }, [activeCompany.certificado, companyData.boSituacaoOrgao]);

  useEffect(() => {
    if (activeCompany.cdTipoPessoaFisica) {
      setPageTitle(intl.formatMessage({ id: 'LABELS.COMMONS.REQUESTER_DATA' }));
      setRequesterType('person');
    }
  }, [activeCompany, intl]);

  useEffect(() => {
    if (Object.keys(companyData).length === 0) {
      history.push(URLS.START);
    }
  }, [companyData, history]);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      if (user.cdUsuarioAdmin && Object.keys(userAdmin).length === 0) {
        await dispatch(fetchUserAdmin(user.cdUsuarioAdmin));
      } else {
        await getLoggedInUser(dispatch);
      }

      setLoading(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user.cdUsuarioAdmin]);

  const breadCrumb = [
    {
      title: pageTitle,
      path: '',
    },
  ];

  const rightInfo = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Paper
          style={{
            textAlign: 'center',
            maxWidth: '250px',
            padding: '10px 20px',
            color: '#666',
          }}
        >
          <h4 style={{ margin: '0', fontSize: '.8em' }}>Situação da empresa no orgão</h4>
          <h3 style={{ margin: '0', fontSize: '1em', color: '#333' }}>{organSituation}</h3>
        </Paper>
      </div>
    );
  };

  return (
    <Container>
      <Breadcrumb breadCrumb={breadCrumb} rightInfo={rightInfo()} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.container} elevation={3}>
            {loading && (
              <div className={classes.centerProgress}>
                <CircularProgress size={20} />
              </div>
            )}
            {!loading && (
              <>
                {requesterType === 'company' && <CompanyData companyData={companyData} />}
                {requesterType === 'person' && <PersonData personData={companyData} />}

                {hasCRC && (
                  <Paper
                    className={classes.crc}
                    onClick={ async () => {
                      await downloadFile({ idFile: companyData.certificado?.idFileCrc, dispatch }, null);
                    }
                  }
                  >
                    <div className={classes.iconCrc}>
                      <InsertDriveFileIcon />
                    </div>
                    <div className={classes.infosCrc}>
                      <h3>
                        <FormattedMessage id="LABELS.COMPANY.CRC" />
                      </h3>
                      <h4>
                        <FormattedMessage id="LABELS.COMPANY.CRC_TEXT" />
                      </h4>
                    </div>
                  </Paper>
                )}
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default injectIntl(Company);
